// LIVE-12 中繼節流：即時影像走 relay（TURN）時——
//   - 使用者閒置（整頁沒有滑鼠 / 鍵盤 / 觸控操作）IDLE_MS → 提示，再 GRACE_MS 沒反應就斷線
//   - 單次連續 MAX_MS 到期 → 斷線，要按「繼續觀看」重新連
// 區網 / direct 不受限。數值是預設（規格：依量測確認）。

export interface RelayLimits {
  idleMs: number;
  graceMs: number;
  maxMs: number;
}

export const RELAY_LIMITS: RelayLimits = { idleMs: 5 * 60_000, graceMs: 30_000, maxMs: 30 * 60_000 };

export type RelayVerdict = { kind: 'ok' } | { kind: 'idle_warn'; leftMs: number } | { kind: 'stop'; reason: 'RELAY_IDLE' | 'RELAY_LIMIT' };

/**
 * relaySince：這一次連線開始走 relay 的時間；lastActivity：使用者最後一次操作。
 * 閒置從兩者較晚的算起（剛連上不算閒置）。
 */
export function relayVerdict(
  path: string | null | undefined,
  relaySince: number,
  lastActivity: number,
  now: number,
  lim: RelayLimits = RELAY_LIMITS,
): RelayVerdict {
  if (path !== 'relay') return { kind: 'ok' };
  if (now - relaySince >= lim.maxMs) return { kind: 'stop', reason: 'RELAY_LIMIT' };
  const idle = now - Math.max(lastActivity, relaySince);
  if (idle >= lim.idleMs + lim.graceMs) return { kind: 'stop', reason: 'RELAY_IDLE' };
  if (idle >= lim.idleMs) return { kind: 'idle_warn', leftMs: lim.idleMs + lim.graceMs - idle };
  return { kind: 'ok' };
}

export function isRelayStop(code: string | null | undefined): boolean {
  return code === 'RELAY_IDLE' || code === 'RELAY_LIMIT';
}

// ---- 使用者活動（整頁共用一份） ----

let last = Date.now();
let installed = false;

export function markActivity(now = Date.now()) {
  if (now > last) last = now; // 別的視窗傳來的活動時間可能比本機的舊
}

export function lastActivity(): number {
  if (!installed && typeof window !== 'undefined') {
    installed = true;
    let throttled = 0;
    const on = () => {
      const now = Date.now();
      if (now - throttled < 1000) return; // pointermove 很密：一秒記一次
      throttled = now;
      last = now;
    };
    for (const ev of ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart']) window.addEventListener(ev, on, { passive: true, capture: true });
  }
  return last;
}
